<mp-custom-chip class="entity-number-chip" [chip]="{ label: entityNumber() }" [small]="true" />
